(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer-TDR"] && !Shopify.designMode) return;
  try {
    
(function () {
  var initialized = new WeakSet();

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function parseEndDate(dateStr, utcOffset) {
    if (!dateStr) return null;
    var normalized = dateStr.trim().replace(' ', 'T');
    if (normalized.length === 10) normalized += 'T23:59';
    if (normalized.length === 16) normalized += ':00';
    var offset = (utcOffset || '+02:00').trim();
    if (!/^[+-]\d{2}:\d{2}$/.test(offset)) offset = '+02:00';
    var ts = Date.parse(normalized + offset);
    return isNaN(ts) ? null : ts;
  }

  function initBar(bar) {
    if (initialized.has(bar)) return;
    initialized.add(bar);

    var values = {
      days: bar.querySelector('[data-unit="days"]'),
      hours: bar.querySelector('[data-unit="hours"]'),
      minutes: bar.querySelector('[data-unit="minutes"]'),
      seconds: bar.querySelector('[data-unit="seconds"]')
    };
    var timerEl = bar.querySelector('.hdb-countdown-bar__timer');
    var inDesignMode = window.Shopify && window.Shopify.designMode;
    var intervalId = null;

    function render() {
      var now = Date.now();
      // Datoene leses på nytt hver tick, ikke én gang ved init, så en
      // endring i editoren slår inn uten full sideinnlasting.
      var end = parseEndDate(bar.dataset.endDate, bar.dataset.utcOffset);
      if (timerEl) timerEl.style.display = end ? '' : 'none';

      var startAt = parseEndDate(bar.dataset.startDate, bar.dataset.utcOffset);
      if (startAt && !inDesignMode && now < startAt) {
        bar.classList.add('hdb-countdown-bar--waiting');
        return;
      }
      bar.classList.remove('hdb-countdown-bar--waiting');

      var diff = end ? end - now : 0;
      if (diff <= 0) {
        diff = 0;
        if (bar.dataset.expiredBehavior === 'hide') {
          bar.classList.add('hdb-countdown-bar--expired-hidden');
          return;
        }
      } else {
        // Settes en ny dato fram i tid, skal baren vises igjen.
        bar.classList.remove('hdb-countdown-bar--expired-hidden');
      }

      var totalSeconds = Math.floor(diff / 1000);
      values.days.textContent = pad(Math.floor(totalSeconds / 86400));
      values.hours.textContent = pad(Math.floor((totalSeconds % 86400) / 3600));
      values.minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      values.seconds.textContent = pad(totalSeconds % 60);
    }

    render();
    intervalId = setInterval(render, 1000);
    bar.addEventListener('hdb:dispose', function () { clearInterval(intervalId); });
  }

  function initAll() {
    document.querySelectorAll('.hdb-countdown-bar').forEach(initBar);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
  // Rydder opp når theme-editoren bytter ut seksjonen, så gamle
  // intervaller ikke hoper seg opp mens du redigerer.
  document.addEventListener('shopify:section:unload', function (e) {
    var bars = e.target ? e.target.querySelectorAll('.hdb-countdown-bar') : [];
    Array.prototype.forEach.call(bars, function (b) {
      b.dispatchEvent(new CustomEvent('hdb:dispose'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-sektion-univers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCards(root) {
      root.querySelectorAll('.hdb-card').forEach(function (card) {
        if (card.dataset.hdbInit) return;
        card.dataset.hdbInit = 'true';
        var video = card.querySelector('.hdb-card__video');
        if (!video) return;
        var cardsRow = card.closest('.hdb-hero__cards');
        var videoOnMobile = cardsRow && cardsRow.dataset.videoMobile === 'true';
        var play = function () {
          if (!videoOnMobile && window.matchMedia('(max-width: 749px)').matches) return;
          card.classList.add('is-playing');
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        };
        var stop = function () {
          card.classList.remove('is-playing');
          video.pause();
          video.currentTime = 0;
        };
        card.addEventListener('pointerenter', play);
        card.addEventListener('pointerleave', stop);
        card.addEventListener('focusin', play);
        card.addEventListener('focusout', stop);
        if (videoOnMobile && window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  play();
                } else {
                  stop();
                }
              });
            },
            { threshold: 0.6 }
          );
          io.observe(card);
        }
      });
    }
    initCards(document);
    document.addEventListener('shopify:section:load', function (event) {
      initCards(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
